export default __webpack_public_path__ + "static/exp2-7998019db7bf7cde7e99ab05bc39889b.png";